<nz-form-control>
  <nz-select
    [ngModel]="value"
    (ngModelChange)="onValueChange($event)"
    [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon"
    nzAllowClear
    nzSize="large"
    nzShowSearch
    [nzCustomTemplate]="customSelectTemplate"
    [nzDisabled]="disabled"
    [nzPlaceHolder]="placeholder"
    [class]="showPartnerIcon ? 'search-preffix contacts' : ''"
  >
    <ng-template #customSelectTemplate let-selected>
      <app-avatar-badge [urlProperty]="urlProperty"
                        [labelProperties]="labelProperties"
                        [isCurrency]="isCurrency"
                        [entity]="getPartner(selected?.nzValue)"></app-avatar-badge>
    </ng-template>

    @if (options) {
      @for (item of options; track item) {
        <nz-option
          [nzLabel]="item.name + (item.surName ? ' ' + item.surName : '')"
          [nzValue]="item.id"
          nzCustomContent
        >
          <app-avatar-badge [urlProperty]="urlProperty"
                            [labelProperties]="labelProperties"
                            [isCurrency]="isCurrency"
                            [entity]="item"></app-avatar-badge>
        </nz-option>
      }
    }
  </nz-select>
</nz-form-control>

<ng-template #customClearIcon>
  <app-st-icon class="custom-clear" name="close"></app-st-icon>
</ng-template>

<ng-template #customSelectIcon>
  <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
</ng-template>
